import account from './routes/account'
import frontend from './routes/frontend'

export default [
    account,
    frontend
]
